import React from 'react'
import { Helmet } from 'react-helmet'

function Contact() {
  // var tat = ""
  // var hello = `javascript${tat}:sendemail()`
  var hello = `https://formsubmit.co/b7e0d297ed79ca86eee5e4f30b97e1e2`
  console.log(`${window.location.origin}/website/#/thankyou`)
  return (
    <div>
      <Helmet><title>Contact Us - Deeptam Research Foundation</title></Helmet>
      <div class="container">

        <div class="row">

          <div class="col-xl-8 offset-xl-2 py-5">
            <h1>Contact Us</h1>
            <p class="lead mt-4">Stuck at a problem. Feal free to contact with us and share the problem with us.
              By
              just fill up this Contact Us form.</p>
            <form action={hello} method="POST" id="form">
              <input type="hidden" name="_next" value={`${window.location.origin}/website/#/thankyou`}/>
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <div class="controls">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="form_name">Full Name <span class="text-danger">*</span></label>
                      <input spellcheck="false" id="Name" name="Name" type="text" class="form-control"
                        placeholder="Please enter your full name *" required="required"
                        data-error="Firstname is required." />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="form_email">Email <span class="text-danger">*</span></label>
                      <input spellcheck="false" id="Email" name="Email" type="email"
                        class="form-control" placeholder="Please enter your email *"
                        required="required" data-error="Valid email is required." />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="form_message">Message <span class="text-danger">*</span></label>
                      <textarea spellcheck="false" id="message" name="message"
                        class="form-control message" placeholder="Message for me *" rows="5"
                        required="required" data-error="Please, leave us a message."></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <button class="button btn btn-success btn-send">Submit</button>
                    <span id="load"></span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header" id="modal-header" style={{padding:'35px 50px'}}>
              <h4><span class="glyphicon glyphicon-lock"></span> Contact Us</h4>
              <button type="button" style={{outline: 'none'}} class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body" id="message_sent" style={{padding:'40px 50px'}}>
              <h5 id="message_sent_msg">...</h5>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-danger btn-default pull-left" data-dismiss="modal"><span
                class="glyphicon glyphicon-remove"></span> Close</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Contact



export function Thankyou() {
  return (<>
    <div style={{ height: '100vh', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', }}>

      <svg viewBox="0 0 24 24" height="100px" width="100px" fill="#009900">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29 5.7 12.7a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"></path>
      </svg>

      <h1 style={{ display: 'inline-block', margin: 0, fontSize: "40px", fontWeight: 500, verticalAlign: 'top' }}>Thankyou</h1><div style={{ verticalAlign: 'middle' }}><h2 style={{ fontSize: 20, marginTop: "10px", fontWeight: 'normal' }}>Thankyou for contacting us.</h2></div></div></div>

  </>)
}